import {
  Button,
  Checkbox,
  createStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    saveButton: {
      width: "100%",
      maxWidth: "600px",
    },
    list: {
      width: "100%",
    },
    paper: {
      width: "100%",
      maxWidth: "600px",
      marginBottom: theme.spacing(2),
    },
    title: {
      margin: theme.spacing(2),
    },
  })
);

const SaveButton = React.memo(({ handleSave, kakunin = null }) => {
  const classes = useStyles();

  const showKakunin = kakunin !== null;

  const [isChecked, setIsChecked] = useState(showKakunin ? kakunin : true);

  const handleClickListItem = () => {
    setIsChecked(!isChecked);
  };

  return (
    <>
      {showKakunin && (
        <Paper elevation={2} className={classes.paper}>
          <Typography className={classes.title}>利用者確認欄</Typography>
          <List className={classes.list}>
            <ListItem dense button onClick={handleClickListItem}>
              <ListItemIcon>
                <Checkbox disableRipple checked={isChecked} />
              </ListItemIcon>
              <ListItemText>上記の内容を確認しました</ListItemText>
            </ListItem>
          </List>
        </Paper>
      )}

      <Button
        color="primary"
        variant="contained"
        className={classes.saveButton}
        onClick={handleSave}
        disabled={!isChecked}
      >
        保存する
      </Button>
    </>
  );
});

export default SaveButton;
